"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApplyConfig = void 0;
/**
 *  @since 0.0.1
 */
var getApplyConfig = function (uri) { return function (config) { return function (a, r, k) {
    return (config && config[uri] ? config[uri] : function (a) { return a; })(a, r[uri], k);
}; }; };
exports.getApplyConfig = getApplyConfig;
